export default "__VITE_ASSET__oNVJaeOT__"